export function filterDonutChartSlices<T extends { value: number }>(
  segments: T[],
): T[] {
  return segments.filter((segment) => segment.value > 0);
}

export function hasDonutChartData(
  total: number,
  segments: Array<{ value: number }>,
): boolean {
  return total > 0 && segments.some((segment) => segment.value > 0);
}
